type ClassValue = string | number | null | undefined | false;

/**
 * Minimal class joiner. Deliberately not `clsx` + `tailwind-merge`:
 * this project never needs conflict resolution at runtime, and skipping
 * both keeps ~6 KB out of the client bundle.
 */
export function cn(...values: ClassValue[]): string {
  let out = '';
  for (const value of values) {
    if (!value && value !== 0) continue;
    out = out ? `${out} ${value}` : String(value);
  }
  return out;
}
